/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from 'react';
import Select from 'react-select';
import { any, arrayOf, bool, func, object, objectOf, string } from 'prop-types';

const IS_EMPTY_ERROR_MSG = 'Por favor, completa este campo';
const HumberDropdown = ({ list, onChange, onClick, label, htmlFor, id, required, value }) => {
  const [isEmpty, setIsEmpty] = useState(false);
  const [optDrop, setOptDrop] = useState(false);
  const checkEmpty = e => {
    if (!e) {
      setIsEmpty(IS_EMPTY_ERROR_MSG);
    } else {
      setIsEmpty('');
    }
  };
  return (
    <div className="humber-dropdown">
      <label htmlFor={htmlFor}>
        {label}
        <Select
          id={id}
          options={list}
          placeholder=""
          value={value}
          className="dropdown"
          isSearchable={false}
          onChange={opt => {
            setOptDrop(opt);
            onChange(opt);
          }}
          onClick={() => {
            onClick(true);
          }}
          onBlur={() => {
            if (required) {
              checkEmpty(optDrop);
            }
          }}
        />
      </label>
      {isEmpty ? <small className="simple-error-msg">{IS_EMPTY_ERROR_MSG}</small> : ''}
    </div>
  );
};

HumberDropdown.propTypes = {
  onChange: func.isRequired,
  onClick: func,
  label: string.isRequired,
  htmlFor: string.isRequired,
  id: string.isRequired,
  required: bool,
  value: objectOf(any),
  list: arrayOf(object).isRequired,
};

HumberDropdown.defaultProps = {
  onClick: () => {},
  required: false,
  value: '',
};

export default HumberDropdown;
